import React, { useEffect, useState } from 'react';
import { HojaDeVida } from '../../../service/types/types';
import { Modal, Table } from 'react-bootstrap';
import { HojaDeVidaService } from '../../../service/holaDeVida.service';
import usePagination from '../../../service/utils/usePagination';


type Props = {
  isOpen: boolean; 
  onRequestClose: () => void;
  userId: string 
};


export default function HojaDeVidaModal({isOpen, onRequestClose, userId}:Props) {
    const [hojaDeVidaList, setHojaDeVidaList] = useState<HojaDeVida[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    //const { currentPage, itemsPerPage, nextPage, prevPage } = usePagination(hojaDeVidaList,10);

    useEffect(() => {
        const loadHojaDeVida = async () => {
            setLoading(true);
            try {
                const data = await HojaDeVidaService.findByUser(userId);
                console.log('Fetched hojaDeVida:', data);
                setHojaDeVidaList(data);

            } catch (error) {
                console.error('Error fetching hojaDeVida:', error);
            } finally {
                setLoading(false);
            }
        };

        if (isOpen) {
            loadHojaDeVida();
        }
    }, [isOpen, userId]);

    //const indexOfLastItem = currentPage * itemsPerPage;
    //const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    //const currentItems = hojaDeVidaList.slice(indexOfFirstItem, indexOfLastItem);

    return (
        <Modal show={isOpen} onHide={onRequestClose} size="lg" centered>
            <Modal.Header closeButton>
                <Modal.Title>Hoja de Vida de {userId}</Modal.Title>
            </Modal.Header>
            
        <Modal.Body>
            {loading ? (
                <p>Loading...</p>
            ) : (
                <Table striped bordered hover responsive>
                    <thead>
                        <tr>
                            <th>Fecha Envio</th>
                            <th>Fecha Creation</th>
                            <th>Detalle</th>
                        </tr>
                    </thead>
                    <tbody>
                        {hojaDeVidaList.map(item => (
                            <tr key={item.id}>
                                <td>{item.fecha}</td>
                                <td>{item.createdAt}</td>
                                <td>{item.texto}</td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            )}
        </Modal.Body>
        </Modal>
    );
};
